// Çek / Senet sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.checksNotes';

export const checksNotesGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Çek / Senet sayfası nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Aldığınız ve verdiğiniz tüm çek ve senetleri tek listede izlersiniz: yeni kayıt, seri senet, durum değiştirme (tahsil, ciro, karşılıksız…) ve Excel çıktısı bu sayfadan yapılır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    stats: t(`${G}.regions.stats`, 'Özet kartları'),
    filters: t(`${G}.regions.filters`, 'Arama ve filtreler'),
    toolbar: t(`${G}.regions.toolbar`, 'Yeni Çek / Senet'),
    table: t(`${G}.regions.table`, 'Çek-senet listesi'),
  },
  steps: [
    {
      region: 'stats',
      title: t(`${G}.s1.title`, '1. Özet kartlarını okuyun'),
      text: t(`${G}.s1.text`, 'Alınan Toplam ve Verilen Toplam, silinmemiş tüm alınan / verilen çek ve senetlerin TL karşılığıdır (durumu ne olursa olsun). Portföyde kartı elinizde bekleyen kayıtları, Vadesi Geçmiş kartı ise vadesi geçtiği hâlde hâlâ Portföyde duranları gösterir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Döviz cinsinden kayıtlar, kayıttaki kurla TL\'ye çevrilerek toplanır.'),
        t(`${G}.s1.tip2`, 'Kartlar arama ve filtrelerden etkilenmez; her zaman tüm kayıtları özetler.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Kaydı bulun'),
      text: t(`${G}.s2.text`, 'Arama kutusu belge no, çek numarası, cari adı ve banka adında arar. Filtre simgesi Tür (Çek / Senet), Yön (Alınan / Verilen), Durum ve Vade (Vadesi Geçmiş, Bu Hafta, Bu Ay) seçimlerini açar; yanındaki düğme listeyi vadeye göre Eskiden Yeniye / Yeniden Eskiye sıralar.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s3.title`, '3. Yeni çek, senet veya seri senet ekleyin'),
      text: t(`${G}.s3.text`, '"Yeni Çek" ve "Yeni Senet" tek bir kayıt formu açar. "Seri Senet" aynı cariye taksitli birden çok senedi tek seferde oluşturur. Yenile listeyi tazeler; ⋮ menüsündeki "Excel İndir" listeyi dosyaya aktarır.'),
      tips: [
        t(`${G}.s3.tip1`, 'Alınan çek / senet kaydedilince cari alacaklandırılır (müşterinin borcu azalır); verilen çek / senet kaydedilince cari borçlandırılır (ona olan borcumuz azalır).'),
        t(`${G}.s3.tip2`, 'Kasa ve banka bakiyesi kayıtta değişmez; ancak durum "Tahsil Edildi", "Kısmi Tahsil" veya "Ödendi" yapılınca değişir.'),
        t(`${G}.s3.tip3`, 'Excel İndir; Tür, Yön ve Durum filtrelerine uyar. Arama ve vade filtresi dosyaya yansımaz.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Listeyi okuyun'),
      text: t(`${G}.s4.text`, 'Her satırda belge no, tür, yön, cari, banka, vade tarihi, tutar ve durum görünür. Satıra tıklayınca detay penceresi açılır; orada İşlem Geçmişi sekmesinde kaydın tüm durum değişikliklerini görürsünüz.'),
      tips: [
        t(`${G}.s4.tip1`, 'Turuncu satır ve ⚠ simgesi: Portföyde duran ve vadesi geçmiş kayıt.'),
        t(`${G}.s4.tip2`, 'Yeşil satır: vadesi bugün. Gri satır: vadesi henüz gelmemiş.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Satır işlemlerini (⋮) kullanın'),
      text: t(`${G}.s5.text`, 'Satır sonundaki ⋮ düğmesi Görüntüle, Düzenle, Durum Değiştir ve Sil seçeneklerini açar.'),
      tips: [
        t(`${G}.s5.tip1`, 'Düzenle: yalnız Portföyde veya Ödenmedi durumundaki kayıtlar güncellenebilir. Tutar ya da cari değişirse bağlı cari hareket de buna göre düzeltilir.'),
        t(`${G}.s5.tip2`, 'Durum Değiştir: tahsile verme, tahsil, ciro, teminat, karşılıksız, iade ve iptal adımlarıdır; kasa / banka / cari etkisi seçilen duruma göre oluşur.'),
        t(`${G}.s5.tip3`, 'Sil: önce kayda bağlı cari, banka ve kasa hareketleri listelenir. Onaylarsanız kayıt bu hareketlerle birlikte silinir ve ilgili bakiyeler geri düzeltilir. Silme her durumdaki kayıtta yapılabilir; dikkatli kullanın.'),
        t(`${G}.s5.tip4`, 'Verilen bir çek silinse de kullandığı çek yaprağı deftere geri dönmez.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s6.title`, '6. Sayfalar arasında gezinin'),
      text: t(`${G}.s6.text`, 'Liste uzunsa alttaki sayfalamayı kullanın ve sayfa başına kaç satır görüneceğini seçin (25, 50, 100). Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
